module.exports = __webpack_public_path__ + "img/icon-envelope.061d7b3f.svg";